import * as fromDatatype from "../datatype-library/index";


export interface bl_wms_picking_list_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    picker: fromDatatype.GuidDataFieldInterface;
    running_no: fromDatatype.VarcharDatatypeInterface;
    picking_date: fromDatatype.TimestampTzDatatypeInterface;
    warehouse_hdr_guid: fromDatatype.GuidDataFieldInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    src_gendoc_hdr_guid : fromDatatype.GuidDataFieldInterface;
    src_gendoc_server_doc_1 : fromDatatype.VarcharDatatypeInterface;
    src_gendoc_server_doc_type : fromDatatype.VarcharDatatypeInterface;
    packing_status : fromDatatype.VarcharDatatypeInterface;
    entity_branch_code : fromDatatype.VarcharDatatypeInterface;
    entity_branch_guid   : fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid : fromDatatype.GuidDataFieldInterface;
    entity_hdr_json : fromDatatype.JsonDatatypeInterface;
    billing_json : fromDatatype.JsonDatatypeInterface;
    delivery_entity_json  : fromDatatype.JsonDatatypeInterface;

}


export class bl_wms_picking_list_hdr_RowClass
    implements bl_wms_picking_list_hdr_RowInterface {
        guid: fromDatatype.GuidDataFieldInterface;
        picker: fromDatatype.GuidDataFieldInterface;
        running_no: fromDatatype.VarcharDatatypeInterface;
        picking_date: fromDatatype.TimestampTzDatatypeInterface;
        warehouse_hdr_guid: fromDatatype.GuidDataFieldInterface;
        descr: fromDatatype.VarcharDatatypeInterface;
        remarks: fromDatatype.VarcharDatatypeInterface;
        status: fromDatatype.StatusDataFieldInterface;
        created_date: fromDatatype.TimestampTzDatatypeInterface;
        updated_date: fromDatatype.TimestampTzDatatypeInterface;
        created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
        revision: fromDatatype.GuidDataFieldInterface;
        vrsn: fromDatatype.VrsnDataFieldInterface;
        src_gendoc_hdr_guid : fromDatatype.GuidDataFieldInterface;
        src_gendoc_server_doc_1 : fromDatatype.VarcharDatatypeInterface;
        src_gendoc_server_doc_type : fromDatatype.VarcharDatatypeInterface;
        entity_hdr_guid : fromDatatype.GuidDataFieldInterface;
        entity_hdr_json : fromDatatype.JsonDatatypeInterface;
        billing_json : fromDatatype.JsonDatatypeInterface;
        delivery_entity_json  : fromDatatype.JsonDatatypeInterface;
        packing_status : fromDatatype.VarcharDatatypeInterface;
        entity_branch_code : fromDatatype.VarcharDatatypeInterface;
        entity_branch_guid   : fromDatatype.GuidDataFieldInterface;

}